import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <Section bg="cream" data-id="element-296">
      <div className="max-w-4xl mx-auto text-center" data-id="element-297">
        <div className="mb-12" data-id="element-298">
          <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-299">
            Confianza Absoluta
          </p>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-300">
            Garantía Wellaging de 7 Días
          </h2>
          <p className="text-xl text-olive font-serif italic" data-id="element-301">
            Resultados Reales o Te Devolvemos Cada Peso
          </p>
        </div>

        <div className="glass-card rounded-[2.5rem] p-10 md:p-16 text-left relative overflow-hidden" data-id="element-302">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-303" />

          <div className="max-w-2xl mx-auto relative z-10" data-id="element-304">
            <p className="text-lg font-light text-charcoal-light mb-8 leading-relaxed" data-id="element-305">
              Entiendo tu escepticismo. La industria del antiaging te mintió
              durante décadas. Por eso voy a hacer algo diferente. Todo el
              riesgo está de mi lado.
            </p>

            <div className="bg-white/50 border border-gold/10 rounded-2xl p-8 mb-10" data-id="element-306">
              <h3 className="font-serif text-2xl text-charcoal mb-6 text-center" data-id="element-307">
                Cómo funciona:
              </h3>
              <ul className="space-y-4 text-charcoal-light font-light" data-id="element-308">
                <li className="flex items-center gap-4" data-id="element-309">
                  <span className="text-gold font-serif italic text-xl" data-id="element-310">
                    01.
                  </span>
                  <span data-id="element-311">Descargá el Método Wellaging 360° hoy.</span>
                </li>
                <li className="flex items-center gap-4" data-id="element-312">
                  <span className="text-gold font-serif italic text-xl" data-id="element-313">
                    02.
                  </span>
                  <span data-id="element-314">Implementá el plan durante 7 días.</span>
                </li>
                <li className="flex items-center gap-4" data-id="element-315">
                  <span className="text-gold font-serif italic text-xl" data-id="element-316">
                    03.
                  </span>
                  <span data-id="element-317">Observá cómo cambia tu energía y tu piel.</span>
                </li>
              </ul>
            </div>

            <div className="text-center" data-id="element-318">
              <p className="font-serif text-2xl text-charcoal mb-4" data-id="element-319">
                Si no funciona, te devolvemos tu dinero.
              </p>
              <p className="text-charcoal-light font-light mb-10" data-id="element-320">
                Sin preguntas. Sin letras chicas.
              </p>

              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Stylized_signature_of_Florencia.svg/1200px-Stylized_signature_of_Florencia.svg.png" alt="Firma Florencia" className="h-12 mx-auto opacity-40 grayscale" onError={e => e.currentTarget.style.display = 'none'} data-id="element-321" />
              <p className="font-serif italic text-charcoal-light mt-2" data-id="element-322">
                Dra. Florencia Bertotto
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}